module.exports = __webpack_public_path__ + "static/media/10-ball.13b45008.png";